import {
  Col,
  Form,
  Input,
  Row,
  Select
} from 'antd'
import React, { useEffect } from 'react'
import { OPTIONS_RECRUITMENT, OPTIONS_TYPE_REQUEST } from '../../configData'
import SelectField from '../common/Select/SelectField'
import Note from './Note'

const   FormPost = ({
  form,
  data,
  handleSearch,
}) => {
  useEffect(() => {
   if(data) {
    form.setFieldsValue(data)
   }
  }, [data])

  console.log("daararaara", data)
return (
  <>
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSearch}
      // labelCol={{ span: 8 }}
      labelAlign="right"
      style={{
        marginTop: 10,
        overflow: 'auto',
        overflowX: 'hidden',
        padding: '0px 10px'
      }}
      onValuesChange={(value, allValues) =>
        console.log('vaaaaaa', value, allValues)
      }
    >
        <Form.Item label="" name="id" style={{ display: 'none' }}>
          <Input />
        </Form.Item>
        <Row gutter={16}>
  <Col span={8}>
    <Form.Item label="Dự án" name="project_recommend_id" >
      <Input placeholder='Nhập dự án' disabled/>
    </Form.Item>
  </Col>
  <Col span={8}>
    <Form.Item label="Họ tên" name="user_id">
      <Input placeholder='Nhập họ và tên' disabled/>
    </Form.Item>
  </Col>
  <Col span={8}>
    <Form.Item label="Số điện thoại" name="user_info">
      <Input placeholder='Nhập số điện thoại' disabled/>
    </Form.Item>
  </Col>
</Row>

<Row gutter={16}>
  <Col span={8}>
      <Form.Item
      label="Nhu cầu"
      name="type_request"
  >
    <Select
    disabled
      placeholder="Chọn loại yêu cầu"
      options={OPTIONS_TYPE_REQUEST.map((opt) => ({
        value: opt.value,
        label: opt.name,
      }))}
    />
  </Form.Item>
  </Col>
  <Col span={8}>
    <Form.Item label="Người yêu cầu" name="customer_name">
      <Input placeholder='Nhập người yêu cầu' disabled/>
    </Form.Item>
  </Col>
  <Col span={8}>
    <Form.Item label="Email yêu cầu" name="customer_email">
      <Input placeholder='Nhập email yêu cầu' disabled/>
    </Form.Item>
  </Col>
</Row>

<Row gutter={16}>
  <Col span={8}>
    <Form.Item label="SĐT yêu cầu" name="customer_phone">
      <Input placeholder='Nhập sđt yêu cầu' disabled/>
    </Form.Item>
  </Col>
  <Col span={8}>
    <Form.Item label="Trạng thái" name="status">
    <Select
      placeholder="Chọn loại yêu cầu"
      options={OPTIONS_RECRUITMENT.map((opt) => ({
        value: opt.value,
        label: opt.name,
      }))}
    />
    </Form.Item>
  </Col>
</Row>
    </Form>
    <Note postId={data?.id} />
  </>
)
}

export default FormPost

